import {parseLines} from '../parse'
import {compile} from '../codegen'
import {transform} from '../transform'

process.on('message', ({id, command, args}) => {
	// console.log('start task', id)
	const startTime = Date.now()
	let result, error
	switch (command) {
		case 'parse':
			try {
				result = parseLines(...args)
			} catch (e) {
				error = e
			}
			break
		case 'codegen':
			try {
				result = compile(...args)
			} catch(e) {
				error = e
			}
		case 'transform':
		default:
			error = new Error('Unknown command: ' + command)
	}
	const endTime = Date.now()
	process.send({id, command, result, error, time: endTime - startTime})
	// console.log('end task', id)
})
